import { makeStyles } from '@material-ui/styles'
export const BackButtonNavBarStyles = (
  topMargin = { xs: 0, sm: 0, md: 0, lg: 0 },
) =>
  makeStyles((theme) => ({
    categoryTitle: {
      color: theme.palette.primary.headerText,
      marginLeft: '8px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '80dvw',
      [theme.breakpoints.only('sm')]: {
        maxWidth: '90dvw',
      },
      [theme.breakpoints.only('xs')]: {
        maxWidth: '80dvw',
      },
    },
    topBackBar: {
      width: '100%',
      height: '60px',
      maxHeight: '60px',
      paddingLeft: '4px',
      position: 'fixed',
      alignContent: 'center',
      zIndex: 100,
      boxShadow: '0 2px 4px rgba(0,0,0,0.04)',
      backgroundColor: theme.palette.button.hover,
      top: topMargin.lg || 0,
      [theme.breakpoints.only('md')]: {
        top: topMargin.md || 0,
      },
      [theme.breakpoints.only('sm')]: {
        top: topMargin.sm || 0,
        paddingLeft: '0px',
      },
      [theme.breakpoints.only('xs')]: {
        top: topMargin.xs || 0,
        paddingLeft: '0px',
      },
    },
    iconButton: {
      border: `2px solid ${theme.palette.primary.headerText}`,
      color: theme.palette.primary.headerText,
      width: 40,
      height: 40,
      borderRadius: '50%',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '20px',
    },
    backButton: {
      display: 'flex',
      alignItems: 'center',
      textTransform: 'none',
      // backgroundColor: 'transparent',
      backgroundColor: theme.palette.button.hover,
      '& .MuiButton-startIcon': {
        marginRight: 12,
      },
    },
  }))

// Export a default function that returns the default styles
export default BackButtonNavBarStyles
